<template>
    <div>
      <div class="mod-home">
        <!-- <h3>富文本编辑</h3> -->
        <el-upload
          v-show="false"
          class="upload-demo"
          :action="uploadImgUrl"
          :headers="uploadHeaders"
          accept="image/jpeg,image/png,image/bmp"
          :before-upload="handleBeforeUpload"
          :on-success="handleSuccess"
          :show-file-list="false"
        >
          <el-button
            v-show="false"
            class="ivu-btn"
            size="small"
            type="primary"
          ></el-button>
        </el-upload>
        <quill-editor
          class="ql-editor"
          v-model="valuemy"
          ref="QuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        ></quill-editor>
      </div>
      <!-- <div class="btn">
        <el-button type="primary" @click="handleContent">确定</el-button>
        <el-button @click="handleReset">重置</el-button>
      </div> -->
    </div>
  </template>
  <script>
  import "@/components/quill-editor/VueQuillEditor.js";
  import { titleConfig } from "@/components/quill-editor/titleConfig.js"; // 富文本文本提示语
  export default {
    props:['valuemy'],
    mounted(){
    
    },
    watch:{
      valuemy(n,o){
        // console.log(n,o)
      }
    },
    data() {
      return {
        fileSize: 10,
        uploadHeaders: {
          // 图片上传接口请求头
          Authorization: "token",
          Platform: "web",
        },
        uploadImgUrl: "/upload", // 上传的图片服务器地址
        content: this.valuemy,
        editorOption: {
          placeholder: "请在这里输入",
          modules: {
            toolbar: {
              container: [
                ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
                ["blockquote", "code-block"], //引用，代码块
                [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
                [{ list: "ordered" }, { list: "bullet" }], //列表
                [{ script: "sub" }, { script: "super" }], // 上下标
                [{ indent: "-1" }, { indent: "+1" }], // 缩进
                [{ direction: "rtl" }], // 文本方向
                [{ size: ["small", false, "large", "huge"] }], // 字体大小
                [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
                [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
                [{ font: [] }], //字体
                [{ align: [] }], //对齐方式
                ["clean"], //清除字体样式
                ["image"], //上传图片
                ['image','video','link']    //上传图片、上传视频、上传文件
                // ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
                // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
                // [{ align: [] }], // 对齐方式-----[{ align: [] }]
                // [{ size: fontSizeStyle.whitelist }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
                // [{ font: fonts }], // 字体种类-----[{ font: [] }]
                // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                // [{ direction: "ltl" }], // 文本方向-----[{'direction': 'rtl'}]
                // [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
                // [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
                // [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
                // [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
                // ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
                // ["clean"], // 清除文本格式-----['clean']
                // ["link", "image", "video"], // 链接、图片、视频-----['link', 'image', 'video']
              ],
              handlers: {
                image: function(value) {
                  if (value) {
                    // 调用iview图片上传
                    document.querySelector(".upload-demo .ivu-btn").click();
                  } else {
                    this.quill.format("image", false);
                  }
                },
              },
            },
          },
        },
      };
    },
    // 在dom创建完成后再调用
    mounted() {
      // 富文本提示信息
      this.$nextTick(() => {
        const oToolBar = document.getElementsByClassName("ql-editor")[0];
        const aButton = oToolBar.querySelectorAll("button");
        const aSelect = oToolBar.querySelectorAll("select");
        aButton.forEach(function(item) {
          if (item.className === "ql-script") {
            item.value === "sub" ? (item.title = "下标") : (item.title = "上标");
          } else if (item.className === "ql-indent") {
            item.value === "+1"
              ? (item.title = "向右缩进")
              : (item.title = "向左缩进");
          } else {
            item.title = titleConfig[item.classList[0]];
          }
        });
        aSelect.forEach(function(item) {
          item.parentNode.title = titleConfig[item.classList[0]];
        });
      });
    },
    methods: {
      onEditorBlur(e) {
        // console.log(e.html, "失去焦点事件");
      },
      onEditorFocus(e) {
        // console.log(e, "获得焦点事件");
      },
      onEditorChange(e) {
     
        // console.log(this.html)

        this.$emit('input',e.html)
      },
      // 上传前校检格式和大小
      handleBeforeUpload(file) {
        // 检验文件类型
        const isIMAGE =
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/bmp";
        if (!isIMAGE) {
          this.$message.error(`请上传图片类型文件！`);
          return false;
        }
        // 校检文件大小
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
        return true;
      },
      handleSuccess(res) {
        // 获取富文本组件实例
        let quill = this.$refs.QuillEditor.quill;
        // 如果上传成功
        if (res.code === 0) {
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, "image", res.data);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          // 提示信息，需引入Message
          this.$message.error("图片插入失败");
        }
      },
  
      handleContent() {},
      handleReset() {
        let quill = this.$refs.QuillEditor.quill;
        // console.log(quill, "quillquill");
        // quill.container.innerHTML = "";
      },
    },
  };
  </script>
  
  <style>
  .mod-home {
    line-height: 1.5;
  }
  .btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
  </style>
  